import RoutePathInfo, { fromRdcSectionToRouteListItemSection as map } from './RoutePathInfo'

export const fromRdcSectionToRouteListItemSection = map
export default RoutePathInfo
